import React from 'react';
import './KitContainer.scss';

type KitContainerProps = {
  title: string | React.ReactNode;
  description?: string;
  warning?: string | React.ReactNode;
  children?: React.ReactNode;
  Button?: React.ReactNode;
  style?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
};
const KitContainer = (props: KitContainerProps) => {
  const { title, description, warning, children, Button, style, buttonStyle } = props;
  return (
    <div className="kit-container" style={style}>
      <div>
        <div className="kit-container-title">{title}</div>
        {description && <div className="kit-container-description">{description}</div>}
        {warning && <div className="kit-container-warning">{warning}</div>}
      </div>
      {children}
      <div
        style={{
          display: 'flex',
          position: 'absolute',
          top: 22,
          right: 30,
          ...buttonStyle,
        }}
      >
        {Button}
      </div>
    </div>
  );
};

export default KitContainer;
